import {UPDATE_FAQ} from '../mutationTypes';

export default {
  [UPDATE_FAQ](state, data) {
    if (data && data.data) {
      state.faq = data.data;
    }
  },
};
